import { WhiteLabelSubdomainInfo } from '../../api/budgetApiClient'
import { FlowEntryStatemachineAction } from '../actions/flowEntryStatemachineActions'

export enum FlowEntryStatemachineStatus {
	UNDECIDED = 'undecided',
	IN_FLOW = 'in-flow',

	RETRIEVING_WHITELABEL_SUBDOMAIN_DATA = 'retrieving-whitelabel-subdomain-data',
	IN_WHITELABEL_SUBDOMAIN = 'in-whitelabel-subdomain',

	BAD = 'bad',
}

export interface FlowEntryStatemachineState {
	status: FlowEntryStatemachineStatus
	whitelabelSubdomainInfo?: WhiteLabelSubdomainInfo
}

const INITIAL_STATE: FlowEntryStatemachineState = {
	status: FlowEntryStatemachineStatus.UNDECIDED,
}

const undecidedStateReducer = (
	state: FlowEntryStatemachineState,
	action: FlowEntryStatemachineAction,
): FlowEntryStatemachineState => {
	switch (action.type) {
		case 'smartCheckFlowOrchestrator/goToFlow':
			return {
				...state,
				status: FlowEntryStatemachineStatus.IN_FLOW,
			}
		case 'smartCheckFlowOrchestrator/goToWhitelabelSubdomainLanding':
			return {
				...state,
				status:
					FlowEntryStatemachineStatus.RETRIEVING_WHITELABEL_SUBDOMAIN_DATA,
			}
		default:
			return state
	}
}

const retrievingWhitelabelSubdomainDataReducer = (
	state: FlowEntryStatemachineState,
	action: FlowEntryStatemachineAction,
): FlowEntryStatemachineState => {
	switch (action.type) {
		case 'smartCheckFlowOrchestrator/WhitelabelSubdomainDataRetrievedSuccessfully':
			return {
				...state,
				whitelabelSubdomainInfo: action.payload,
				status: FlowEntryStatemachineStatus.IN_WHITELABEL_SUBDOMAIN,
			}
		default:
			return state
	}
}

const inWhitelabelSubdomainStatusReducer = (
	state: FlowEntryStatemachineState,
	action: FlowEntryStatemachineAction,
): FlowEntryStatemachineState => {
	switch (action.type) {
		case 'smartCheckFlowOrchestrator/goToFlow':
			return {
				...state,
				status: FlowEntryStatemachineStatus.IN_FLOW,
			}
		default:
			return state
	}
}

const inFlowStatusReducer = (
	state: FlowEntryStatemachineState,
	action: FlowEntryStatemachineAction,
): FlowEntryStatemachineState => {
	switch (action.type) {
		//  No transitions
		default:
			return state
	}
}

export default function reduce(
	state: FlowEntryStatemachineState = INITIAL_STATE,
	action: FlowEntryStatemachineAction,
): FlowEntryStatemachineState {
	switch (state.status) {
		case FlowEntryStatemachineStatus.UNDECIDED:
			return undecidedStateReducer(state, action)
		case FlowEntryStatemachineStatus.IN_FLOW:
			return inFlowStatusReducer(state, action)
		case FlowEntryStatemachineStatus.RETRIEVING_WHITELABEL_SUBDOMAIN_DATA:
			return retrievingWhitelabelSubdomainDataReducer(state, action)
		case FlowEntryStatemachineStatus.IN_WHITELABEL_SUBDOMAIN:
			return inWhitelabelSubdomainStatusReducer(state, action)
		default:
			//	TODO log as error
			return state
	}
}
